import { faAngleDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ScheduleFrequencyId } from '@spike/new-booking-model';
import clsx from 'clsx';
import { SelectDropdown } from 'components/UI/V3/SelectDropdown/SelectDropdown';
import { useMasterData } from 'hooks';
import { FunctionComponent, useMemo } from 'react';
import { RecurrenceFrequencyOption, getFrequencyOptions } from 'model/RecurringSeries';
import StepSection from './StepSection';
import styles from './RecurringSeriesSteps.module.scss';

interface RepeatStepProps {
    frequency: RecurrenceFrequencyOption | undefined;
    onChangeFrequency: (frequency: RecurrenceFrequencyOption | undefined) => void;
}

export const RepeatStep: FunctionComponent<RepeatStepProps> = props => {
    const masterData = useMasterData();

    const options = useMemo(
        () => getFrequencyOptions(masterData.scheduleFrecuency ?? []),
        [masterData.scheduleFrecuency]
    );

    const selected = options.find(option => option.id === props.frequency?.id) ?? null;

    const changeFrequency = (id: ScheduleFrequencyId | undefined) =>
        props.onChangeFrequency(options.find(option => option.id === id));

    return (
        <StepSection
            number={1}
            title="Repeat"
        >
            <div>
                <span className={styles.fieldLabel}>Frequency</span>
                <SelectDropdown<ScheduleFrequencyId>
                    options={options}
                    value={selected}
                    dropdownProps={{ align: 'start', zIndex: 1301, minWidth: 214, maxHeight: 300 }}
                    trigger={
                        <div className={clsx(styles.field, styles.frequencyField)}>
                            <span className={clsx(styles.fieldValue, { [styles.fieldPlaceholder]: !selected })}>
                                {selected?.label ?? 'Select Frequency'}
                            </span>
                            <FontAwesomeIcon
                                icon={faAngleDown}
                                className={styles.fieldIcon}
                            />
                        </div>
                    }
                    onChange={option => changeFrequency(option?.id)}
                />
            </div>
        </StepSection>
    );
};

export default RepeatStep;
